<template>
  <div id="HomeClock" class="text-center">
    <h3 class="display-1">{{hours}}:{{minutes}}</h3>
    <hr class="w-25 bg-white">
    <h4 class="clockSize">{{day}} {{date}}.{{month}}.{{year}}</h4>
  </div>
</template>

<script>
export default {
  name: 'HomeHeader',
  methods: {
    clock () {
      let today = new Date()
      this.hours = this.addZero(today.getHours())
      this.minutes = this.addZero(today.getMinutes())

      this.year = today.getFullYear()
      this.month = this.addZero(today.getMonth() + 1)
      this.date = this.addZero(today.getDate())
      this.day = this.setDay(today.getDay())

      setTimeout(this.clock, 1000)
    },
    addZero(i) {
      if (i < 10) {
        i = '0' + i
      }

      return i
    },
    setDay(i) {
      let day = ''
      switch(i) {
        case 0 :
          day = 'Sonntag'
          break
        case 1 :
          day = 'Montag'
          break
        case 2 :
          day = 'Dienstag'
          break
        case 3 :
          day = 'Mittwoch'
          break
        case 4 :
          day = 'Donnerstag'
          break
        case 5 :
          day = 'Freitag'
          break
        case 6 :
          day = 'Samstag'
          break
      }

      return day
    }
  },
  data () {
    return {
      hours: '',
      minutes: '',
      day: '',
      date: '',
      month: '',
      year: ''
    }
  },
  mounted () {
    this.clock()
  }
}
</script>

<style scoped>
.clockSize {
  font-size: 3rem
}

  @media screen and (max-width: 576px) {
    .display-1 {
      font-size: 5rem;
    }

    .display-4 {
      font-size: 2rem;
    }
  }

  @media screen and (min-width: 577px) and (max-width: 992px) {
    .display-1 {
      font-size: 5rem;
    }

    .display-4 {
      font-size: 2rem;
    }
  }
</style>